import graphql from './graphql';

const query = /* GraphQL */ `
  query CourseCategory_list {
    CourseCategory_list {
      id
      name
    }
  }
`;

const courseCategoryList = async () =>
  // eslint-disable-next-line camelcase
  graphql(query).then(({ CourseCategory_list }) => CourseCategory_list);

export default courseCategoryList;
